import { render, staticRenderFns } from "./LearningObjectives.vue?vue&type=template&id=a23747b6"
import script from "./LearningObjectives.vue?vue&type=script&lang=js"
export * from "./LearningObjectives.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LearningObjectiveTile: require('/vercel/path0/components/LearningObjectiveTile.vue').default})
